<template>
    <!-- Row layout: small square button left, label beside it, chevron right -->
    <div v-if="horizontal" class="flex w-full min-w-0 cursor-pointer items-center gap-3">
        <div
            class="bg-bg flex size-12 shrink-0 items-center justify-center border border-zinc-700"
        >
            <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="h-1/2 w-1/2"
            >
                <path
                    d="M17.3333 8L17.3333 14.6667L24 14.6667L24 17.3333L17.3333 17.3333L17.3333 24L14.6667 24L14.6667 17.3333L8 17.3333L8 14.6667L14.6667 14.6667L14.6667 8L17.3333 8Z"
                    fill="white"
                />
            </svg>
        </div>
        <span class="flex-1 text-sm font-medium text-white"><slot /></span>
        <svg
            width="9"
            height="14"
            viewBox="0 0 9 14"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="mr-1 shrink-0"
        >
            <path
                d="M-1.23621e-07 12L5.29297 6.70703L-1.04907e-06 1.41406L1.41406 5.86347e-07L8.12109 6.70703L1.41406 13.4141L-1.23621e-07 12Z"
                fill="white"
            />
        </svg>
    </div>

    <!-- Tile layout (default) -->
    <div v-else class="relative flex w-full min-w-0 flex-col">
        <div
            class="bg-bg flex aspect-square w-full items-center justify-center border border-zinc-700"
        >
            <svg
                width="32"
                height="32"
                viewBox="0 0 32 32"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                class="h-1/2 w-1/2"
            >
                <path
                    d="M17.3333 8L17.3333 14.6667L24 14.6667L24 17.3333L17.3333 17.3333L17.3333 24L14.6667 24L14.6667 17.3333L8 17.3333L8 14.6667L14.6667 14.6667L14.6667 8L17.3333 8Z"
                    fill="white"
                />
            </svg>
        </div>
        <div class="mt-2 w-full">
            <span class="line-clamp-2 overflow-hidden text-ellipsis text-sm font-medium text-white"
                ><slot
            /></span>
        </div>
        <div class="avatarBG"></div>
    </div>
</template>

<script>
export default {
    name: 'PlayerAddCard',
    props: {
        /** Render as a horizontal row (small button + label) instead of a tile. */
        horizontal: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
